<template>
  <div id="app">
    <router-view></router-view>
    <NotificationWidget></NotificationWidget>
    <ChatWidget></ChatWidget>
  </div>
</template>

<script>
import { useAuthStore } from '@/stores/authStore';
import NotificationWidget from './components/NotificationWidget.vue';
import ChatWidget from './components/ChatWidget.vue';
import { onBeforeUnmount, computed, watch } from 'vue';

export default {
  name: 'App',
  components: {
    NotificationWidget,
    ChatWidget,
  },
  created() {
    // Ustaw motyw na podstawie zapisanego stanu w localStorage
    document.title = "Aplikacja do Zarządzania";
    this.setThemeFromLocalStorage();
  },
  setup() {
    const authStore = useAuthStore();

    const isDispatcher = computed(() =>
        authStore.isAuthenticated && ['ROLE_YOUNG_DISPATCHER', 'ROLE_ADULT_DISPATCHER'].includes(authStore.user.role)
    );

    const isAdmin = computed(() => authStore.isAuthenticated && authStore.user.role === 'ROLE_ADMIN');

    watch(
        () => authStore.isAuthenticated,
        (newValue) => {
          if (newValue) {
            authStore.startSessionCheck();
            console.log("Użytkownik zalogowany - rozpoczęto cykliczne sprawdzanie sesji.");
          } else {
            authStore.stopSessionCheck();
            console.log("Użytkownik wylogowany - zatrzymano cykliczne sprawdzanie sesji.");
          }
        },
        {immediate: true}
    );

    onBeforeUnmount(() => {
      authStore.stopSessionCheck();
      console.log("Zatrzymano cykliczne sprawdzanie sesji przy demontowaniu komponentu.");
    });

    return {
      authStore,
      isDispatcher,
      isAdmin,
    };
  },
  methods: {
    setThemeFromLocalStorage() {
      const savedTheme = localStorage.getItem('theme') || 'light'; // Pobierz zapisany motyw
      const isDarkMode = savedTheme === 'dark';
      document.documentElement.classList.toggle('dark', isDarkMode); // Ustaw motyw
    },
    async logout() {
      try {
        const authStore = useAuthStore();
        await authStore.logout(true);

        // Ustaw zapisany motyw po wylogowaniu
        this.setThemeFromLocalStorage();

        this.$router.push('/login');
      } catch (error) {
        console.error('Błąd podczas wylogowania:', error);
      }
    },
  },
};
</script>
